// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllDownloads__container-ab6530 {
  --all-downloads-height: 44px;
  --all-downloads-show-transition: 0.3s ease;
  position: relative;
  z-index: 1;
  margin-bottom: calc(var(--all-downloads-height) * -1);
  box-sizing: border-box;
  transition: all var(--all-downloads-show-transition);
}

.AllDownloads__container-ab6530.AllDownloads__show-d31d8f {
  margin-bottom: 0;
}

.AllDownloads__panel-d83809 {
  display: block;
  padding: 6px 8px;
  cursor: pointer;
  background-color: var(--base-0);
  border-top: 1px solid var(--base-20);
  width: 100%;
  height: var(--all-downloads-height);
  transition: border-top-color var(--all-downloads-show-transition);
  position: relative;
}

.AllDownloads__panel-d83809.AllDownloads__list-open-c0b3c4 {
  border-color: var(--base-20);
}

.AllDownloads__panel-inner-container-ac2c11 {
  display: flex;
  align-items: center;
}

.AllDownloads__panel-text-df745a {
  margin-inline-start: 12px;
}

.AllDownloads__arrow-e8c04b {
  min-width: 32px;
  height: 32px;
  margin-inline-start: auto;
  fill: var(--base-80);
  transform: rotate(0);
  transition: transform var(--all-downloads-show-transition);
}

.AllDownloads__arrow-e8c04b.AllDownloads__list-open-c0b3c4 {
  transform: rotate(-180deg);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/AllDownloads/AllDownloads.styles.m.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,0CAAA;EAEA,kBAAA;EACA,UAAA;EACA,qDAAA;EACA,sBAAA;EACA,oDAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,oCAAA;EACA,WAAA;EACA,mCAAA;EACA,iEAAA;EACA,kBAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,oBAAA;EACA,0DAAA;AAAF;;AAGA;EACE,0BAAA;AAAF","sourcesContent":[".container {\n  --all-downloads-height: 44px;\n  --all-downloads-show-transition: 0.3s ease;\n\n  position: relative;\n  z-index: 1;\n  margin-bottom: calc(var(--all-downloads-height) * -1);\n  box-sizing: border-box;\n  transition: all var(--all-downloads-show-transition);\n}\n\n.container.show {\n  margin-bottom: 0;\n}\n\n.panel {\n  display: block;\n  padding: 6px 8px;\n  cursor: pointer;\n  background-color: var(--base-0);\n  border-top: 1px solid var(--base-20);\n  width: 100%;\n  height: var(--all-downloads-height);\n  transition: border-top-color var(--all-downloads-show-transition);\n  position: relative;\n}\n\n.panel.list-open {\n  border-color: var(--base-20);\n}\n\n.panel-inner-container {\n  display: flex;\n  align-items: center;\n}\n\n.panel-text {\n  margin-inline-start: 12px;\n}\n\n.arrow {\n  min-width: 32px;\n  height: 32px;\n  margin-inline-start: auto;\n  fill: var(--base-80);\n  transform: rotate(0);\n  transition: transform var(--all-downloads-show-transition);\n}\n\n.arrow.list-open {\n  transform: rotate(-180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AllDownloads__container-ab6530`,
	"show": `AllDownloads__show-d31d8f`,
	"panel": `AllDownloads__panel-d83809`,
	"list-open": `AllDownloads__list-open-c0b3c4`,
	"listOpen": `AllDownloads__list-open-c0b3c4`,
	"panel-inner-container": `AllDownloads__panel-inner-container-ac2c11`,
	"panelInnerContainer": `AllDownloads__panel-inner-container-ac2c11`,
	"panel-text": `AllDownloads__panel-text-df745a`,
	"panelText": `AllDownloads__panel-text-df745a`,
	"arrow": `AllDownloads__arrow-e8c04b`
};
module.exports = ___CSS_LOADER_EXPORT___;
